
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-medal-line',
      title: 'Educadores Especializados',
      description: 'Profesionales con formación especializada y amplia experiencia en educación infantil.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Atención Individualizada',
      description: 'Cada niño recibe un trato personalizado adaptado a sus necesidades y ritmo de desarrollo.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Espacios Seguros',
      description: 'Instalaciones limpias, seguras y perfectamente adaptadas para los más pequeños.'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Rutinas Respetuosas',
      description: 'Respetamos el ritmo natural de cada niño con rutinas flexibles y amorosas.'
    },
    {
      icon: 'ri-chat-heart-line',
      title: 'Comunicación Constante',
      description: 'Mantenemos una comunicación cercana y transparente con todas las familias.'
    },
    {
      icon: 'ri-sun-line',
      title: 'Instalaciones Modernas y Luminosas',
      description: 'Espacios diseñados para el bienestar, con luz natural y materiales de primera calidad.'
    }
  ];

  return (
    <section id="why" className="py-20 bg-[#A8C5B0]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">¿Por qué elegirnos?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Elegir escuela infantil es una decisión importante. Aquí cuidamos, acompañamos y educamos de verdad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#A8C5B0]/20 rounded-full mb-4">
                <i className={`${reason.icon} text-2xl text-[#7BA388]`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
